"use client"
/* */
const locales = {"de-DE": {  "textFieldBase.characters": (args, formatter) => `${formatter.select({0: () => `${args.count}`, other: () => `${args.count}/${args.maxCount}`}, args.maxCount)} Zeichen`,
},"en-US": {  "textFieldBase.characters": (args, formatter) => `${formatter.select({0: () => `${args.count}`, other: () => `${args.count}/${args.maxCount}`}, args.maxCount)} characters`,
}};

export { locales as default };
//# sourceMappingURL=_.locale.json@444629885187f8ca5450a1c8b14fb45c.mjs.map
